var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"l-autobuyers-tab"},[_vm._l((_vm.multiple),function(type,id){return _c('MultipleAutobuyersBox',{key:id,attrs:{"type":type}})}),_c('MultipleSingleAutobuyersGroup')],2)}
var staticRenderFns = []

export { render, staticRenderFns }